import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import {BoostrapModalService} from "./core/services/boostrap-modal/boostrap-modal.service";
import {InactivityService} from "./core/services/inactivity/inactivity.service";
import {Router, NavigationEnd} from "@angular/router";
import {filter} from "rxjs/operators";

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  modalShowing=false;
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private boostrapModalService: BoostrapModalService,
    private inactivityService: InactivityService,
    private router: Router,
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );
  }

  ngOnInit() {
    this.modeService.init();
    this.initSessionTimeout();
  }

  private initSessionTimeout(): void {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        const isAuthRoute = (e.urlAfterRedirects as string).startsWith('/auth');
        if (isAuthRoute) {
          // On login/logout pages stop watching — no session to guard
          this.inactivityService.stop();
        } else {
          // On any protected route start (or keep) the inactivity watch
          this.inactivityService.start();
        }
      });
  }
}
